import {
  BuildingFragment,
  HeatingOrCoolingSource,
  ProviderFragment,
  ProviderType,
} from '../generated/graphql'
import { Provider } from '../calculators/providers/common/Provider'

export function isProviderConnectedToEnergyBus(
  provider: ProviderFragment | Provider,
): boolean {
  return (
    provider.type === ProviderType.HybridHeatPump &&
    provider.parameters.__typename === 'HybridHeatPumpParameters' &&
    (provider.parameters.baseHeatSource === HeatingOrCoolingSource.EnergyBus ||
      provider.parameters.freeCoolingSource ===
        HeatingOrCoolingSource.EnergyBus ||
      provider.parameters.coolingSource === HeatingOrCoolingSource.EnergyBus)
  )
}

export function isConnectedToEnergyBus(building: BuildingFragment): boolean {
  return building.providers.some(isProviderConnectedToEnergyBus)
}
